<template>
  <div>
    <h1><span v-lang.headline></span></h1>
    <table>
      <tr>
        <td>ANALYTICA</td>
        <td>München</td>
        <td>10. - 13. April 2018</td>
        <td><a href="https://www.analytica.de/">https://www.analytica.de/</a></td>
      </tr>
      <tr>
        <td>ACHEMA</td>
        <td>Frankfurt</td>
        <td>11.-15. Juni 2018</td>
        <td><a href="https://www.achema.de/">https://www.achema.de/</a></td>
      </tr>
      <tr>
        <td>Labvolution</td>
        <td>Hannover</td>
        <td>21.-23. Mai 2019</td>
        <td><a href="https://www.labvolution.de/">https://www.labvolution.de/</a></td>
      </tr>
      <tr>
        <td>ArabLab</td>
        <td>Dubai</td>
        <td>12.-14. März 2019</td>
        <td><a href="https://www.arablab.com/">https://www.arablab.com/</a></td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  name: 'Tradefairs',
  data () {
    return {}
  },
  messages: {
    de:{
      headline: 'Messen und Ausstellungen'
    },
    en: {
      headline: 'Tradefairs'
    }
  }
};
</script>
<style scoped>
h1{
  color: black;
}
table,td {
  color: black;
  border: 1px black solid;
  border-collapse: collapse;
}
div {
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/tradefairs.vue